import { useNavigate } from "react-router-dom";
import {
  Box,
  IconButton,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useEffect, useState } from "react";
import ReplyIcon from "@mui/icons-material/Reply";
import AddReply from "../../Modals/addReply";
import AddRatingReply from "../../Modals/ratingreply";
import { useLazyGetRatingListQuery } from "../../service/rating";
import { showError } from "../../constants/toasts";
import dayjs from "dayjs";
import Loader from "../../constants/Loader";
import CustomPagination from "../../components/CustomPagination";
import { isValidInput } from "../../utils/validations";

const Ratings = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [getRatingList] = useLazyGetRatingListQuery();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState<any>("");
  const [ratingList, setRatingList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const getRatingListApi = async () => {
    try {
      setLoading(true);
      const response = await getRatingList({
        page: debouncedSearchTerm ? 1 : page,
        limit: debouncedSearchTerm ? 1000 : 10,
        // Bypass backend search since it only searches by review
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        let list = response?.data?.list || [];
        let total = response?.data?.total || 0;

        if (debouncedSearchTerm) {
          const term = debouncedSearchTerm.toLowerCase();
          list = list.filter((item: any) => {
            const storeName = item?.vendor?.storeName?.toLowerCase() || "";
            const email = item?.vendor?.email?.toLowerCase() || "";
            const phone = item?.vendor?.phone?.toLowerCase() || "";
            const bookingId = item?.bookingId?.toLowerCase() || "";
            const review = item?.review?.toLowerCase() || "";
            const reply = item?.reply?.toLowerCase() || "";

            return (
              storeName.includes(term) ||
              email.includes(term) ||
              phone.includes(term) ||
              bookingId.includes(term) ||
              review.includes(term) ||
              reply.includes(term)
            );
          });

          // Implement simple client-side pagination for the filtered results
          total = list.length;
          const startIndex = (page - 1) * 10;
          list = list.slice(startIndex, startIndex + 10);
        }

        setRatingList(list);
        setCount(total);
      } else {
        setRatingList([]);
        setCount(0);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };
  useEffect(() => {
    setPage(1);
  }, [debouncedSearchTerm]);

  useEffect(() => {
    getRatingListApi();
  }, [page, debouncedSearchTerm]);
  const [rows] = useState([
    {
      id: 1,
      name: "Alice Johnson",
      email: "alice.johnson@example.com",
      phone: "+91 9876543210",
      orderId: "#BOOK_001",
      productId: "#PRD_001",
      rating: 5,
      review: "Excellent product, fast delivery!",
      date: "20 Oct 2025",
    },
    {
      id: 2,
      name: "Bob Smith",
      email: "bob.smith@example.com",
      phone: "+91 9123456789",
      orderId: "#BOOK_002",
      productId: "#PRD_003",
      rating: 4,
      review: "Good quality but packaging could be better.",
      date: "18 Oct 2025",
    },
    {
      id: 3,
      name: "Carol Williams",
      email: "carol.williams@example.com",
      phone: "+91 9988776655",
      orderId: "#BOOK_003",
      productId: "#PRD_007",
      rating: 3,
      review: "Average experience. Expected faster delivery.",
      date: "16 Oct 2025",
    },
  ]);

  const columns = [
    { id: "srNo", label: "Sr. No." },
    { id: "userDetails", label: "Vendor Details" },
    { id: "orderId", label: "Booking ID" },
    { id: "rating", label: "Rating" },
    { id: "review", label: "Review" },
    { id: "reply", label: "Reply" },
    { id: "date", label: "Date" },
    { id: "action", label: "Action" },
  ];

  return (
    <>
      <Loader isLoad={loading} />
      <div className="main_title">
        <h1>Manage Ratings & Reviews</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Ratings & Reviews
        </p>
      </div>

      <div className="cards">
        {/* Table Header */}
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                value={searchTerm}
                onChange={(e: any) => isValidInput(e.target.value) && setSearchTerm(e.target.value)}
                onCross={() => {
                  setSearchTerm("");
                  setDebouncedSearchTerm("");
                }}
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                placeholder="Search By Booking ID..."
              />
            </Box>
          </div>
        </div>

        {/* Table */}
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow hover>
                {columns.map((column) => (
                  <TableCell key={column.id}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {ratingList.length > 0 ? (
                ratingList?.map((item, index) => (
                  <TableRow hover key={item?.id}>
                    <TableCell>{index + 1}</TableCell>

                    {/* User Details */}
                    <TableCell>
                      <div className="user_block">
                        <figure>
                          <img
                            src="/static/images/user_placeholder.png"
                            alt="User"
                          />
                        </figure>
                        <p>
                          <b>{item?.vendor?.storeName}</b>
                          {item?.vendor?.email}
                          <br />
                          {item?.vendor?.phone}
                        </p>
                      </div>
                    </TableCell>

                    <TableCell>{item?.bookingId || "-"} </TableCell>

                    {/* Rating */}
                    <TableCell>
                      {"⭐".repeat(item?.rating)}
                      {item?.rating < 5 ? "☆".repeat(5 - item?.rating) : ""}
                    </TableCell>
                    <TableCell className="max_c2">{item?.review}</TableCell>
                    <TableCell className="max_c2">{item?.reply || "-"}</TableCell>
                    <TableCell>
                      {item?.date
                        ? dayjs(item?.date).format("DD MMMM YYYY")
                        : "-"}
                    </TableCell>
                    {/* Actions */}
                    <TableCell>
                      <div className="table_actions v2">
                        {item?.reply ? "-" : (
                          <Box>
                            <IconButton
                              onClick={() => {
                                setSelectedItem(item);
                                setOpenModal(true);
                              }}
                            >
                              <ReplyIcon />
                            </IconButton>
                          </Box>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No records found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {count > 0 ? (
        <CustomPagination
          currentPage={page - 1}
          count={count}
          pageSize={10}
          onPageChange={(page) => setPage(page + 1)}
        />
      ) : null}

      {/* ✅ Pass all required props */}
      <AddRatingReply
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        selectedItem={selectedItem}
        onSuccess={getRatingListApi}
      />
    </>
  );
};

export default Ratings;
